<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'SaveButton',

    functional: true,

    props: {
        type: {type: String, default: 'button'},
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        isLoading: {type: Boolean},
        disabled: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.save'),
            iconClass: 'fa fa-check',
            color: 'btn-primary',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            isLoading: props.isLoading,
            disabled: props.disabled,
            type: props.type,
        };

        return createElement(BaseButton, data);
    },
};
</script>
